import { DropdownMenu } from '@dittolive/anvil'
import graphql from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import paths from 'paths'
import { useEffect } from 'react'
import { useLazyLoadQuery, useRefetchableFragment } from 'react-relay/hooks'
import { useNavigate } from 'react-router-dom'

import { PersonalAppsMenuItem_viewer$key } from './__generated__/PersonalAppsMenuItem_viewer.graphql'
import { PersonalAppsMenuItemQuery } from './__generated__/PersonalAppsMenuItemQuery.graphql'
import { ViewerAppsRefetchQuery } from './__generated__/ViewerAppsRefetchQuery.graphql'

const query = graphql`
  query PersonalAppsMenuItemQuery {
    viewer {
      ...PersonalAppsMenuItem_viewer
    }
  }
`

const refetchableApps = graphql`
  fragment PersonalAppsMenuItem_viewer on Viewer
  @refetchable(queryName: "ViewerAppsRefetchQuery") {
    me {
      # eslint-disable-next-line relay/unused-fields
      id
      apps {
        # eslint-disable-next-line relay/unused-fields
        id
        slug
        name
      }
    }
  }
`

type Props = {
  /** True if the menu item is open */
  isOpen: boolean
}

// Menu item for accessing the user's personal apps.
export default function PersonalAppsMenuItem({ isOpen }: Props) {
  const { viewer } = useLazyLoadQuery<PersonalAppsMenuItemQuery>(query, {})
  const [data, refetch] = useRefetchableFragment<
    ViewerAppsRefetchQuery,
    PersonalAppsMenuItem_viewer$key
  >(refetchableApps, viewer)

  useEffect(() => {
    if (isOpen) {
      refetch({}, { fetchPolicy: 'store-and-network' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const navigate = useNavigate()

  const apps = data?.me?.apps ?? []

  const { databasesText, isRenamed } = useAppToDatabaseRename()

  return (
    <>
      {apps.length > 0 ? (
        apps.map((userApp, index) => {
          const redirectTo = paths.app({
            appSlug: userApp.slug,
            isRenamed,
          })

          return (
            <DropdownMenu.Item
              key={index}
              onSelect={() => navigate(redirectTo)}
            >
              {userApp.name}
            </DropdownMenu.Item>
          )
        })
      ) : (
        <DropdownMenu.Item disabled>
          You do not have any {databasesText} yet
        </DropdownMenu.Item>
      )}
    </>
  )
}
